import React from 'react';
import { useEffect, useState, useCallback, forwardRef, useImperativeHandle } from 'react';
import { useTranslation } from 'react-i18next';
import { useAppSelector, useAppDispatch } from '../../../hooks';
import ItemOfStaffImage from './ItemOfStaffImage';
import { getToken } from 'helpers';
import { rankingAction } from 'slices/rankingSlice';
import ModalChangeImage from './ModalChangeImage';
import ModalViewImage from './ModalViewImage';
import { errorToast, successToast } from 'helpers';

type props = {
  setOpenModalDeleteImage: React.Dispatch<React.SetStateAction<boolean>>;
};

const StaffImages = forwardRef<any, props>(
  (
    {
      // setSelectedStaff,
      // listStaff,
      // setListStaff,
      // setOpenModalViewImage,
      // setOpenModalChangeImage,
      setOpenModalDeleteImage,
    },
    ref
  ) => {
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const token = getToken() as string;

    const selectShop = useAppSelector((state) => state.shopList.selectShop);
    const hostForOrderList = useAppSelector((state) => state.ranking.hostForOrderList);
    const userStaff = useAppSelector((state) => state.ranking.userStaff);

    const [loading, setLoading] = useState(false);
    const [listStaff, setListStaff] = useState<any>([]);
    const [selectedStaff, setSelectedStaff] = useState<any>({});
    const [openModalViewImage, setOpenModalViewImage] = useState(false);
    const [openModalChangeImage, setOpenModalChangeImage] = useState(false);

    const leftColumn = listStaff?.filter((_: any, index: number) => index % 2 === 0);
    const rightColumn = listStaff?.filter((_: any, index: number) => index % 2 === 1);
    const onSave = async () => {
      try {
        let listStaffUpdate = [...listStaff].filter((item) => item.isUpdateImagePosRanking);
        const updatePromises = listStaffUpdate.map((staff) => {
          return dispatch(
            rankingAction.updateImageSettingAvatarRanking({
              token,
              data: {
                shop_id: selectShop.id,
                imageFile: staff?.image_app_pos_ranking,
                id: staff?.id,
                // time_update_avatar: moment().unix(),
              },
            })
          );
        });
        await Promise.all(updatePromises);
      } catch (error) {
        console.log(error);
      }
    };
    const onDelete = async () => {
      if (
        (selectedStaff?.avatar_ranking && selectShop?.id) ||
        selectedStaff?.id === userStaff?.id
      ) {
        await dispatch(
          rankingAction.updateImageSettingAvatarRanking({
            token,
            data: {
              shop_id: selectShop?.id,
              imageFile: null,
              id: selectedStaff?.id,
              delete_avatar_ranking: 1,
              // time_update_avatar: moment().unix(),
            },
          })
        );
        setTimeout(() => {
          successToast('スタッフ画像が正常に削除されました');
        }, 2000);
      }
      const newListStaff = listStaff?.map((item: any) => {
        if (item?.id === selectedStaff?.id) {
          return {
            ...item,
            image_app_pos_ranking: {},
            imageUrl: {},
            avatar_ranking: null,
          };
        }
        return item;
      });
      setListStaff(newListStaff);
      setOpenModalDeleteImage(false);
    };
    useImperativeHandle(ref, () => ({
      onSave,
      onDelete,
    }));

    useEffect(() => {
      if (hostForOrderList.data.length > 0) {
        setListStaff(
          [...(hostForOrderList.data || [])]
            .sort((x: any, y: any) => (y?.orderby_staff || 0) - (x?.orderby_staff || 0))
            .map((obj: any) => ({ ...obj, image_app_pos_ranking: {} }))
            .filter(
              (staff: any) =>
                String(staff.nick_name).toLocaleLowerCase() !== 'master' && staff.cid_user !== 10
            )
        );
      }
    }, [JSON.stringify(hostForOrderList.data)]);

    useEffect(() => {
      if (selectShop?.id) {
        dispatch(
          rankingAction.fetchHostForOrderList({
            token,
            params: { shopId: selectShop?.id, per_page: 1000 },
          })
        );
      }
    }, [selectShop?.id]);

    return (
      <div
        style={{ height: window.innerHeight - (80 + 24 + 50) }}
        className="flex overflow-y-auto flex-col flex-1 px-4 pt-3 h-full"
      >
        <span className="text-[#252B37] text-xl notosans_bold">{t('STAFF_IMAGES')}</span>
        {/* PC */}
        <div className="hidden w-full lg:flex">
          <div className="flex-1 mr-4">
            {leftColumn?.map((x: any, y: number) => {
              return (
                <ItemOfStaffImage
                  item={x}
                  index={y}
                  setSelectedStaff={setSelectedStaff}
                  setOpenModalViewImage={setOpenModalViewImage}
                  loading={loading}
                  setListStaff={setListStaff}
                  listStaff={listStaff}
                  setOpenModalChangeImage={setOpenModalChangeImage}
                  setOpenModalDeleteImage={setOpenModalDeleteImage}
                  // selectImage={selectImage}
                />
              );
            })}
          </div>
          <div className="w-px bg-[#D5D7DA]"></div>
          <div className="flex-1 ml-4">
            {rightColumn?.map((x: any, y: number) => {
              return (
                <ItemOfStaffImage
                  item={x}
                  index={y}
                  setSelectedStaff={setSelectedStaff}
                  setOpenModalViewImage={setOpenModalViewImage}
                  loading={loading}
                  setListStaff={setListStaff}
                  listStaff={listStaff}
                  setOpenModalChangeImage={setOpenModalChangeImage}
                  setOpenModalDeleteImage={setOpenModalDeleteImage}
                  // selectImage={selectImage}
                />
              );
            })}
          </div>
        </div>
        {/* Mobile */}
        <div className="flex flex-col w-full lg:hidden">
          {listStaff?.map((x: any, y: number) => {
            return (
              <ItemOfStaffImage
                item={x}
                index={y}
                setSelectedStaff={setSelectedStaff}
                setOpenModalViewImage={setOpenModalViewImage}
                loading={loading}
                setListStaff={setListStaff}
                listStaff={listStaff}
                setOpenModalChangeImage={setOpenModalChangeImage}
                setOpenModalDeleteImage={setOpenModalDeleteImage}
                // selectImage={selectImage}
              />
            );
          })}
        </div>
        <ModalViewImage
          open={openModalViewImage}
          setOpen={setOpenModalViewImage}
          setOpenModalDeleteImage={setOpenModalDeleteImage}
          selectedStaff={selectedStaff}
          setSelectedStaff={setSelectedStaff}
        />
        <ModalChangeImage
          open={openModalChangeImage}
          setOpen={setOpenModalChangeImage}
          selectedStaff={selectedStaff}
          setSelectedStaff={setSelectedStaff}
        />
      </div>
    );
  }
);
export default StaffImages;
